import api from "./api";
import { toSearchFilter } from "../utils";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_CAMERAS = API_URL_VERSION + "cameras"
export const ENDPOINT_CAMERAS_LIST = ENDPOINT_CAMERAS + "/listar"

export const cameraService = {
  list: async (params) => {
    try {
      const response = await api.post(ENDPOINT_CAMERAS_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.list";
    }
  },

  findMany: async (data) => {
    try {
      const response = await api.get(ENDPOINT_CAMERAS_LIST, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.find-many";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_CAMERAS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_CAMERAS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_CAMERAS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.update";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_CAMERAS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.delete";
    }
  },

  lookup: async () => {
    try {
      const response = await api.get(ENDPOINT_CAMERAS_LIST);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.camera.messages.errors.list";
    }
  },
};
